import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Flex,
  Icon,
  Text,
} from 'react-orange-ui';

const IconMargin = styled(Icon)`
  margin-right: 1rem;
`;

const Container = styled.div`
  margin: 1rem 0;
`;

const Title = ({
  id, label, icon, size, color,
}) => (
  <Container>
    <Flex alignItems="center">
      <IconMargin id={`${id}-icon`} icon={icon} width={size} height={size} color={color} />
      <Text size="l" bold id={`${id}-label`}>
        { label }
      </Text>
    </Flex>
  </Container>
);

Title.propTypes = {
  /** Id title */
  id: PropTypes.string.isRequired,
  /** Title label */
  label: PropTypes.string.isRequired,
  /** Icon name */
  icon: PropTypes.string.isRequired,
  /** Icon width and height */
  size: PropTypes.oneOf([12, 16, 24, 32, 64, 128, 256]),
  /** Icon color */
  color: PropTypes.string,
};

Title.defaultProps = {
  size: 24,
  color: 'black',
};

export default Title;
